export const Role = () => (
  <svg
    width='48'
    height='48'
    viewBox='0 0 48 48'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g filter='url(#filter0_d_4538_52020)'>
      <rect x='4' width='40' height='40' rx='8' fill='#37A2BA' />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M15.3661 20.3782C15.3661 18.3497 15.9676 16.3668 17.0946 14.6801C18.2216 12.9935 19.8234 11.679 21.6974 10.9027C23.5715 10.1264 25.6337 9.92331 27.6232 10.319C29.6127 10.7148 31.4402 11.6916 32.8746 13.1259C34.3089 14.5603 35.2857 16.3878 35.6815 18.3773C36.0772 20.3668 35.8741 22.429 35.0978 24.3031C34.3216 26.1771 33.007 27.7789 31.3204 28.9059C29.6337 30.0329 27.6508 30.6344 25.6223 30.6344C25.0364 30.6344 24.5613 31.1094 24.5613 31.6954C24.5613 32.2813 25.0364 32.7564 25.6223 32.7564C28.0705 32.7564 30.4637 32.0304 32.4993 30.6703C34.5349 29.3101 36.1214 27.3769 37.0583 25.1151C37.9951 22.8533 38.2403 20.3645 37.7627 17.9633C37.285 15.5622 36.1061 13.3566 34.375 11.6255C32.6439 9.89437 30.4383 8.71546 28.0372 8.23785C25.6361 7.76023 23.1472 8.00536 20.8854 8.94224C18.6236 9.87911 16.6904 11.4657 15.3302 13.5012C13.9701 15.5368 13.2441 17.93 13.2441 20.3782C13.2441 20.9642 13.7192 21.4392 14.3051 21.4392C14.8911 21.4392 15.3661 20.9642 15.3661 20.3782Z'
        fill='white'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M9.31076 16.8068C8.89641 17.2212 8.89641 17.893 9.31076 18.3073L13.0546 22.0511C13.7451 22.7417 14.8648 22.7417 15.5553 22.0511L19.2991 18.3073C19.7135 17.893 19.7135 17.2212 19.2991 16.8068C18.8848 16.3925 18.213 16.3925 17.7986 16.8068L14.3049 20.3006L10.8112 16.8068C10.3969 16.3925 9.7251 16.3925 9.31076 16.8068Z'
        fill='white'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M24.9204 13.6641C25.5063 13.6641 25.9813 14.1391 25.9813 14.725V21.2884L29.1198 23.7991C29.5773 24.1652 29.6515 24.8328 29.2855 25.2904C28.9194 25.748 28.2518 25.8221 27.7942 25.4561L24.3107 22.6693C24.0254 22.4411 23.8594 22.0956 23.8594 21.7303V14.725C23.8594 14.1391 24.3344 13.6641 24.9204 13.6641Z'
        fill='white'
      />
    </g>
    <defs>
      <filter
        id='filter0_d_4538_52020'
        x='0'
        y='0'
        width='48'
        height='48'
        filterUnits='userSpaceOnUse'
        color-interpolation-filters='sRGB'
      >
        <feFlood flood-opacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='4' />
        <feGaussianBlur stdDeviation='2' />
        <feComposite in2='hardAlpha' operator='out' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0'
        />
        <feBlend
          mode='normal'
          in2='BackgroundImageFix'
          result='effect1_dropShadow_4538_52020'
        />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='effect1_dropShadow_4538_52020'
          result='shape'
        />
      </filter>
    </defs>
  </svg>
)
